// Proposer categories, ids must match proposer_category in the API (ProposerHelper)
export const PROPOSER_CATEGORIES = [
  { id: '1', name: 'Организација' },
  { id: '2', name: 'Самостални предлог' },
  { id: '3', name: 'Предлог органа власти и тела са јавним овлашћењима' },
  { id: '4', name: 'Изостављен предлагач у Решењу' }
];

// Categories shown only by category name, without individual proposer names
const GROUPED_CATEGORY_IDS = ['2', '4'];

export function proposerLabel(categoryId, organizationName) {
  const id = String(categoryId ?? '');
  if (GROUPED_CATEGORY_IDS.includes(id)) {
    return PROPOSER_CATEGORIES.find(c => c.id === id).name;
  }
  return organizationName?.trim() || '—';
}
